export default "/static/webpack/media/big-five-diagram-nb.021d3a57.png";